import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationInterceptorService } from './authentication-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    AuthenticationService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptorService, multi: true },
  ]
})
export class AuthenticationModule { }
